export default __webpack_public_path__ + "static/media/8b9c2d05d5473f6895ce3e6e39f87eac.png";